import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="page-container"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="flex-1 space-y-6">
            <motion.h1 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-5xl md:text-6xl font-bold"
            >
              Welcome to <span className="text-gradient">SofiMileroy</span> Digital Art Gallery
            </motion.h1>
            
            <motion.p 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="text-xl text-muted-foreground"
            >
              Explore a world where digital art meets emotion, bringing your imagination to life through unique illustrations and designs.
            </motion.p>
            
            <motion.div 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="flex gap-6 items-center"
            >
              <Link to="/projects">
                <Button className="flex items-center gap-2 text-sm">
                  View Works
                </Button>
              </Link>
              <a 
                href="https://ko-fi.com/mileroy" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center gap-2 text-sm font-medium hover:text-primary transition-colors duration-300"
              >
                <Heart className="w-4 h-4" />
                Support
              </a>
            </motion.div>
          </div>
          
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="flex-1 relative"
          >
            <div className="relative w-full aspect-square rounded-2xl overflow-hidden">
              <img  
                className="w-full h-full object-cover"
                alt="Night sky with pink clouds and stars"
                src="/homepage-hero.jpg"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Home;
